/**
 * SILCA LINK LOCALIZATION FIX
 * -----------------------------------------------------------------------------
 * Questo script assicura che gli utenti rimangano nella loro lingua corrente
 * quando cliccano su link interni hardcoded (che puntano alla lingua di default).
 *
 * Funzionamento Universale:
 * 1. Rileva AUTOMATICAMENTE la root corrente da Shopify.
 * - Esempi rilevati: "/de-de", "/es-es", "/fr-fr", "/de-at"
 * 2. Se siamo nella lingua di default ("/"), non fa nulla.
 * 3. Se siamo in una lingua alternativa (es. Spagna "/es-es"), scansiona i link.
 * 4. Aggiunge il prefisso lingua ai link interni che ne sono privi.
 * 5. Monitora il DOM per correggere anche link iniettati dinamicamente.
 */

(function() {
  'use strict';

  // 1. Rilevamento sicuro della root corrente fornita da Shopify
  // Questo valore cambia automaticamente in base al mercato (es. '/es-es' per la Spagna)
  const currentRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  // Se siamo nella root di default (es. Italia "/"), non serve correggere nulla.
  // Termina l'esecuzione per risparmiare risorse.
  if (currentRoot === '/') return;

  // Rimuovi lo slash finale dalla root per pulizia (es. "/es-es/" -> "/es-es")
  const localePrefix = currentRoot.replace(/\/$/, '');

  /**
   * Funzione principale per localizzare un singolo nodo ancora (<a>)
   */
  const localizeAnchor = (anchor) => {
    try {
      // Ignora link senza href o link javascript/mailto/tel
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

      // Crea un oggetto URL per un'analisi sicura
      // Usiamo 'location.origin' come base per i link relativi
      const linkUrl = new URL(href, window.location.origin);

      // CONTROLLO 1: Il link deve essere interno (stesso dominio)
      if (linkUrl.hostname !== window.location.hostname) return;

      // CONTROLLO 2: Ignorare file statici (immagini, pdf, ecc.)
      // Questa regex controlla le estensioni comuni alla fine del path
      if (/\.(jpg|jpeg|png|gif|pdf|css|js|svg)$/i.test(linkUrl.pathname)) return;

      // CONTROLLO 3: Il link ha già il prefisso corretto?
      // Se il pathname inizia con il prefisso locale (es. "/es-es"), è già a posto.
      if (linkUrl.pathname.startsWith(localePrefix)) return;

      // CONTROLLO 4: Evitare di doppiare la root (caso raro ma possibile)
      // Se per qualche motivo il path è esattamente uguale alla root, gestiscilo
      let newPath = linkUrl.pathname;
      if (!newPath.startsWith('/')) newPath = '/' + newPath; // Assicura lo slash iniziale

      // AZIONE: Costruisci il nuovo href
      // Esempio: "/es-es" + "/collections/calze" -> "/es-es/collections/calze"
      const newHref = localePrefix + newPath + linkUrl.search + linkUrl.hash;

      // Applica la modifica al DOM
      anchor.setAttribute('href', newHref);
      
      // Marcatura per debug (opzionale, rimuovere in produzione se si vuole pulizia totale)
      // anchor.setAttribute('data-localized', 'true');

    } catch (e) {
      // Silenzia errori su URL malformati per non rompere il sito
      console.warn('Silca Localization: Errore processando un link', e);
    }
  };

  /**
   * Esegue la localizzazione su tutti i link presenti al momento
   */
  const runLocalization = () => {
    const anchors = document.querySelectorAll('a[href]');
    anchors.forEach(localizeAnchor);
  };

  // Esegui subito al caricamento dello script
  runLocalization();

  // Esegui anche al DOMContentLoaded per sicurezza (se lo script è caricato in head)
  document.addEventListener('DOMContentLoaded', runLocalization);

  /**
   * MUTATION OBSERVER (Advanced)
   * Gestisce contenuti caricati dinamicamente (es. Searchanise, filtri AJAX, Infinite Scroll)
   * Osserva le modifiche al DOM e corregge i nuovi link al volo.
   */
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          // Se il nodo aggiunto è un elemento (non testo)
          if (node.nodeType === 1) {
            // Se è un link, controllalo
            if (node.tagName === 'A') {
                localizeAnchor(node);
            } 
            // Se contiene link al suo interno, segna di rieseguire
            else if (node.querySelector('a')) {
                shouldRun = true;
            }
          }
        });
      }
    });

    if (shouldRun) {
      // Esegui su tutto il documento o (meglio) solo sui nuovi nodi
      // Per semplicità e robustezza, ri-scansioniamo (è molto veloce in JS moderno)
      runLocalization();
    }
  });

  // Avvia l'osservatore sul body
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();